var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('schedule-visit',{attrs:{"visible":_vm.showScheduleVisitForm,"showButtons":"false","buttonValue":"verder"}}),_c('phone-details',{attrs:{"visible":_vm.showPhoneDetailsForm,"buttonValue":"verder"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }